// extracted by css-extract-rspack-plugin
export default {"root":"VacationDaysInfoList_root__Lwg9f"};